export const surveyTypesArr = [
  { id: 1, name: 'ADAPT' },
  { id: 2, name: 'PULSE' },
  { id: 3, name: 'EFFECT' },
];

export const languagesArr = [
  { id: 1, name: 'English' },
  { id: 2, name: 'Norwegian' },
  { id: 3, name: 'Swedish' },
];

export const surveyTypes = {
  ADAPT: 'ADAPT',
  PULSE: 'PULSE',
  EFFECT: 'EFFECT',
};
